import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Course, Pagination } from "services/courseService";

export interface CourseWebState {
  courses: Course[];
  pagination: Pagination | null;
  loading: boolean;
  error: string | null;
}

export const initialState: CourseWebState = {
  courses: [],
  pagination: null,
  loading: false,
  error: null,
};

const courseWebSlice = createSlice({
  name: "courseWeb",
  initialState,
  reducers: {
    setCourseWebLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setCourseWebData(
      state,
      action: PayloadAction<{ courses: Course[]; pagination: Pagination }>
    ) {
      // If we're fetching a single course (1 course in response) and we already have courses,
      // merge the new course with existing courses instead of replacing
      if (action.payload.courses.length === 1 && state.courses.length > 0) {
        const newCourse = action.payload.courses[0];
        const existingIndex = state.courses.findIndex(c => c.id === newCourse.id);
        if (existingIndex >= 0) {
          // Update existing course
          state.courses[existingIndex] = newCourse;
        } else {
          // Add new course to existing list
          state.courses.push(newCourse);
        }
        // Don't update pagination for single course fetches
      } else {
        // Replace entire list (normal behavior for list fetches)
        state.courses = action.payload.courses;
        state.pagination = action.payload.pagination;
      }
      state.error = null;
    },
    setCourseWebError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setCourseWebLoading,
  setCourseWebData,
  setCourseWebError,
} = courseWebSlice.actions;

export default courseWebSlice.reducer;


